package io.horion.cv.models

enum class JobType {
    CDI, CDD, STAGE, FREELANCE, INTERIM, LEARNING
}